export default __webpack_public_path__ + "static/media/startupRealCase2.d106ff85.jpg";